import pricingData from '../data/pricingData.json';

export const BUSINESS_TIER_MULTIPLIERS = [1, 2, 4, 8, 16, 32];

const VALID_BUNDLE_NAMES = ['credit_bundle_ai'];

export function isValidPlan(planName) {
    if (!planName) return false;
    const basePlanId = getBasePlanId(planName);
    const inPricingData = pricingData.plans.some(p => p.id === basePlanId);
    const inBundles = VALID_BUNDLE_NAMES.includes(planName) || VALID_BUNDLE_NAMES.includes(basePlanId);
    return inPricingData || inBundles;
}

export function getTierPlanName(multiplier) {
    if (multiplier === 1) return 'business_ai';
    return `business_${multiplier}x_ai`;
}

export function getMultiplierFromPlanName(planName) {
    if (!planName) return null;
    const cleaned = planName.replace('annual_', '');
    if (cleaned === 'business_ai') return 1;
    const match = cleaned.match(/^business_(\d+)x_ai$/);
    return match ? parseInt(match[1], 10) : null;
}

export function getTierIndex(multiplier) {
    return BUSINESS_TIER_MULTIPLIERS.indexOf(multiplier);
}

export function getMultiplierFromIndex(index) {
    return BUSINESS_TIER_MULTIPLIERS[index] || 1;
}

export function isBusinessTierPlan(planName) {
    return getMultiplierFromPlanName(planName) !== null;
}

export function getBasePlanId(planName) {
    if (!planName) return planName;
    const cleaned = planName.replace('annual_', '');
    if (isBusinessTierPlan(cleaned)) return 'business_ai';
    return cleaned;
}

export function getTierData(multiplier) {
    const businessPlan = pricingData.plans.find(p => p.id === 'business_ai');
    if (!businessPlan || !businessPlan.tiers) return null;
    return businessPlan.tiers.find(t => t.multiplier === multiplier);
}
